/**
 * @generated SignedSource<<66f2b83876e29878d9aaa8274456b04d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDetailEntries_item$data = {
  readonly categoryL2: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly pdpDetailsDisplay: ReadonlyArray<{
    readonly detailKey: string | null;
    readonly detailValues: ReadonlyArray<{
      readonly __typename: string;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "useDetailEntries_item";
};
export type useDetailEntries_item$key = {
  readonly " $data"?: useDetailEntries_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDetailEntries_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useDetailEntries_item",
  "selections": [
    {
      "alias": "categoryL2",
      "args": [
        {
          "kind": "Literal",
          "name": "level",
          "value": 2
        }
      ],
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "getCategoriesByLevel",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": "getCategoriesByLevel(level:2)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PdpDetail",
      "kind": "LinkedField",
      "name": "pdpDetailsDisplay",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "detailValues",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "d1a286fe64f077763cea94e5af828272";

export default node;
